const Badge = ({ className, children, style }) => {
  return (
    <div
      className={`${className} text-xs font-medium me-2 px-2.5 py-1 text-center rounded`}
      style={style}
    >
      {children}
    </div>
  );
};

export default Badge;
